import React, { useRef, useEffect, useState } from 'react';
import Globe from 'globe.gl';

export const GlobeComponent = ({ highlightedCountries }) => {
  const [countriesGeoJson, setCountriesGeoJson] = useState(null);
  const globeRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    fetch('earth.geojson')
      .then(res => res.json())
      .then(data => setCountriesGeoJson(data))
      .catch(error => console.error("GeoJSON loading error:", error));
  }, []);

  useEffect(() => {
    if (!countriesGeoJson || !containerRef.current) return;

    // Get container dimensions
    const containerWidth = containerRef.current.clientWidth;
    const containerHeight = Math.min(500, containerWidth); // Max height of 500px

    const globe = Globe()(globeRef.current)
      //.globeImageUrl('//unpkg.com/three-globe/example/img/earth-dark.jpg')
      .globeImageUrl('earth-dark.jpg')
      .backgroundColor('#ffffff')
      .width(containerWidth)
      .height(containerHeight)
      .hexPolygonsData(countriesGeoJson.features)
      .hexPolygonResolution(3)
      .hexPolygonMargin(0.3)
      .hexPolygonUseDots(true)
      .hexPolygonColor(({ properties: d }) => {
        return highlightedCountries.includes(d.ISO_A2) || highlightedCountries.includes(d.ISO_A3_EH) 
          ? '#32CD32'
          : '#ffffff';
      })
      .hexPolygonAltitude(({ properties: d }) => {
        return highlightedCountries.includes(d.ISO_A2) || highlightedCountries.includes(d.ISO_A3_EH) 
          ? 0.02 
          : 0;
      })
      .atmosphereColor('#4B0082')
      .atmosphereAltitude(0.25);

    // Handle window resize
    const handleResize = () => {
      const newWidth = containerRef.current.clientWidth;
      const newHeight = Math.min(500, newWidth);
      globe.width(newWidth).height(newHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      globe.controls().dispose();
    };
  }, [countriesGeoJson, highlightedCountries]);

  return (
    <div className="w-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg">
      <div 
        ref={containerRef}
        className="relative w-full"
      >
        <div
          ref={globeRef}
          className="flex justify-center items-center"
        />
      </div>
    </div>
  );
};

export default GlobeComponent;